import React, { useEffect } from "react";
import accessdenied from '../../assets/images/access-denied.png'; 

function Unauthorized() { 
  return (
        <div className="favbg">
          <div className="innerwrapper">
            <div className="access-denied">
                <img src={accessdenied} alt="Access Denied"/>
            </div>
          </div>
        </div>
    );
}

export default Unauthorized;